import { useState, useEffect } from 'react'
import Link from 'next/link'

import useSWR from 'swr'

import logger from '../../../lib/logger'
import AppLogo from '../apps/logo'
import SimplePagination from './../../elements/simplePagination'
import AppGridItemPlaceholder from '../apps/appGridItemPlaceholder'


const APPS_PER_PAGE = 12


export default function CategoryApps({ category={}, categories=[], searchText='', apps=[] }) {
  logger.info("Component.CategoryApps rendering.")
  const touched = true 

  const [page, setPage] = useState(0)
  // const searchDataUrl = `${process.env.NEXT_PUBLIC_NEXT_API_URL}/search/searchData`
  const searchDataUrl = `/api/search/searchData`
  const { data={}, error: searchDataError } = useSWR([searchDataUrl]) // fetch at the beginnning
  const { apps: appsDataStatic } = data
  const appsData = (category?.id && apps?.length>0) ? apps : appsDataStatic

  // categories
  const appsDataWithCategories = appsData?.map(app => {
    const { primary_category, ...rest } = app
    const newPrimaryCategory = categories?.find(c => c?.id === primary_category?.id)
    return {...rest, primary_category: {...newPrimaryCategory}}
  })
  const appsSorted = appsDataWithCategories?.sort((a, b) => (parseInt(b?.count_connections) - parseInt(a?.count_connections)))
  const appsFiltered = appsSorted?.filter(app => app?.name?.toLowerCase().startsWith(searchText?.toLowerCase()))

  const countData = appsFiltered?.length
  const maxPages = Math.ceil(countData/APPS_PER_PAGE) 
  const appsThisPage = appsFiltered?.slice(APPS_PER_PAGE*page, APPS_PER_PAGE*(page+1))  
  const appsDisplayed = appsThisPage?.map(a => {
    const { image, ...rest } = a
    return { ...rest, image_updated_at: image || a?.image_updated_at }  // neded for AppLogo to work properly. For /apps we take data from static. For category we take from StaticProps. 
  })
  
  useEffect(() => { setPage(0) }, [searchText]);

  // UI 
  const AppTag = category?.id ? `h2` : `p`  // If it's a category page then use just p for filters cat

   
  return <>

    <div className='pb-12'>
      {/* Apps Grid Header */}
      <div className='my-3 px-1'>          

        {touched && !data ? (
          <p className="text-gray-600">Loading...</p>
        ) : (
          <p className="text-gray-600">
            Showing {page*APPS_PER_PAGE+1} - {Math.min((page+1)*APPS_PER_PAGE, countData)} of { countData } {category?.name} apps </p>              
        )}
               
      </div>
      
      {/* Apps grid */}
      <div className="grid grid-cols-1 gap-y-4 gap-x-6 sm:grid-cols-2 lg:col-span-3 lg:gap-x-6 mb-12">
        {(!touched || data) ? (
          appsDisplayed?.map(app => (
            
            <div key={app?.slug} className="relative flex items-center  space-x-3 rounded-md    
                                          hover:shadow-md bg-white border border-gray-200 text-gray-900 hover:text-crisp-700
                                          focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-crisp-500" >
                                            {/* min-h-full px-3 py-3 */}
              <div className="flex-shrink-0">
                <div className="p-2 border-r border-gray-200">
                  <AppLogo className="h-14 w-14 rounded-md" app={app}/>
                </div>
              </div>
              <div className="flex-1 min-w-0">
                <Link href={`/${app?.slug}`} className="focus:outline-none">

                  <span className="absolute inset-0" aria-hidden="true" />
                  <AppTag className="text-sm font-semibold">
                    {app.name}
                  </AppTag>
                  <p className="text-sm font-normal text-gray-500">
                    {/* {app.title} */}
                    {app?.primary_category?.name}

                  </p>

                </Link>
              </div>
          
            </div>
          ))
        ) : (
          [...Array(APPS_PER_PAGE).keys()].map(item => <AppGridItemPlaceholder key={item} />)            
        )}

      </div>

      <SimplePagination maxPages={maxPages} page={page} setPage={setPage} />   
      
    </div>
  </>;
}
